import React from 'react';
import {connect} from 'react-redux';

// Components
import Input from 'Components/common/Input';
import Anchor from 'Components/common/Anchor';
import Select from 'Components/common/Select';
import BasicButton from 'Components/common/BasicButton';
import util from 'Utils/commonUtil';
import LoadingIcon from 'Components/icons/LoadingIcon';
// Actions
import { getSCList, applyBackup, getPersonalInfo, getAlphaList, getInventoryBySkuAndSC } from 'Actions/userCenter';
import { checkSku, addApplyProduct } from 'Actions/applyListing';
import { openNotification } from 'Actions/notification';
import { T } from 'Actions/translate';

// Icons
import {ArrowBackIos} from '@material-ui/icons';

class ApplyForListing extends React.Component {
    state = {
        sku: '',
        quantity: 1,
        labOrDept: '',
        institution: '',
        scId: undefined,
        date: util.dateFilter(new Date().setDate(new Date().getDate()+5), 'yyyy-MM-dd'),
        remark: '',
        alphaName: '',
        skuInventory: 100,
        backupOnroadQuantity: 0,
        skuModalComps: [{id:1, sku: "", skuInventory: "",}],
        skuNum: 1,
        pageLoading:false,
    };

    componentWillMount() {
        const {localData} = this.props;
        if(this.props.history.location.state && this.props.history.location.state.scId){
            this.setState({scId: this.props.history.location.state.scId})
        }

        this.props.getSCList().then((scList) => {
            if (localData.roleType === 0) {
                this.props.getPersonalInfo().then((personalInfo) => {
                    let labOrDept = undefined;
                    let scId = undefined;

                    personalInfo &&
                        personalInfo.data &&
                        personalInfo.data.shipTos &&
                        personalInfo.data.shipTos.forEach((item) => {
                            if (item.defaultShipTo) {
                                labOrDept = item.stAlphaName;
                            }
                        });

                    scList &&
                        scList.data &&
                        scList.data.forEach((item) => {
                            if (item.id === localData.scId) scId = item.id;
                        });

                    this.setState({
                        labOrDept,
                        scId,
                    });
                });
            }
        });
    }

    getTypeBack = ()=>{
        if(this.props.history.location.state && this.props.history.location.state==='user'){
            this.props.history.push('/userCenter')
        }else if(this.props.history.location.state && this.props.history.location.state.type && this.props.history.location.state.type=='stock'){
            this.props.history.push('/replenishmentSCDetails')
        }
    }

    gotoBackupList = () => {
        this.getTypeBack()
    };

    quantityChange = (value, currentIndex) => {
        let currentSkuModalComps = JSON.parse(JSON.stringify(this.state.skuModalComps));
        currentSkuModalComps.map((skuModal, skuIndex) => {
            if (currentIndex === skuModal.id) {
                skuModal.applyQuantity = value;
            }
        });
        this.setState({
            skuModalComps: currentSkuModalComps
        });
    }
    inputChange = (title, value) => this.setState({[title]: value});
    handleSelectChange = (item) => this.setState({scId: item.id});

    inputSkuChange = (title, value) => {
        this.setState({[title]: value})
    }

    submit = () => {
        const {sku, scId, remark,pageLoading} = this.state;
        this.setState({
            pageLoading:true
        })
        let skuDetails = [];
        let skuModalComps = JSON.parse(JSON.stringify(this.state.skuModalComps));
        skuModalComps.map((skuModal, skuIndex) => {
            skuDetails.push(skuModal.sku.trim());
        });
        const data = {
            skuList: [...new Set(skuDetails)],
            scId: scId,
            remark: remark,
        };

        // console.log(data,"data")

        let isNotNull = true;
        let currentSkuModalComps = JSON.parse(JSON.stringify(this.state.skuModalComps));
        currentSkuModalComps.map((skuModal, skuIndex) => {
            if (!skuModal.sku) {
                isNotNull = false;
            }
        });
        if (!isNotNull)
            return this.props.openNotification(
                T('pleaseEnter') + T('sku'),
                'danger',
            );
        if (!scId)
            return this.props.openNotification(
                T('backup_supply_center_placeholder'),
                'danger',
            );
        //确认申请
        this.props.addApplyProduct(data).then((res) => {
            if(res.status==='success'){
                this.setState({
                    pageLoading:false
                })
                this.props.openNotification(
                    T('notification_successfully_applied_for_sku_listing'),
                );
                this.getTypeBack()
            } 
        }).catch((error)=>{
            this.setState({
                pageLoading:false
            })
            switch(error.status) {
                case 'BLACK_SKU':
                    this.props.openNotification(T('submit_sku_is_in_black_list'));
                   break;
                case 'NOT_EXISTS':
                    this.props.openNotification(T('submit_sku_is_invalid_sku'));
                   break;
                case 'EXIST_IN_CURRENT_SC':
                    this.props.openNotification(T('submit_sku_is_exist_in_current_SC'));
                   break;
                case 'HAS_NO_LIST_PRICE':
                    this.props.openNotification(T('submit_sku_no_have_list_price'));
                   break;
                default:
                    this.props.openNotification(T('submitFail'));
           }
        })
    };

    handleSearch  = (name, item, serachFlg) => {
        if (typeof serachFlg === 'undefined') {
            if (item.trim()) {
                this.props.getAlphaList(item.trim());
                this.setState({
                    alphaName: item
                });
            } else {
                this.setState({
                    alphaName: item,
                    institution: ''
                });
            }
        } else {
            this.setState({
                alphaName: item.fullName,
                institution: item.institution
            });
        }
    }

    inputSkuQueryChange = (title, value) => {
        let number = parseInt(title.slice(3));
        let currentSkuModalComps = JSON.parse(JSON.stringify(this.state.skuModalComps));
        currentSkuModalComps.map((skuModal, skuIndex) => {
            if (number === skuModal.id) {
                skuModal.sku = value;
            }
        });
        
        this.setState({
            [title]: value,
            skuModalComps: currentSkuModalComps
        })
    }
    
    blurSkuQueryChange = (currentSkuIndex) => {
        let currentSkuModalComps = JSON.parse(JSON.stringify(this.state.skuModalComps));
        let currentSku = 0;
        currentSkuModalComps.map((skuModal, skuIndex) => {
            if (currentSkuIndex === skuModal.id) {
                currentSku = skuModal.sku;
            }
        });
        const {scId} = this.state;
        if (typeof scId === 'undefined') {
            this.props.openNotification(T('backup_supply_center_placeholder'));
        } else {
            if (currentSku.trim()) {
                let params = {
                    "scId":scId,
                    "sku": currentSku.trim()
                }
                this.props.checkSku(params).then((res) => {
                    if (res.status === 'success') {
                            currentSkuModalComps.map((backupSkuModal, madalIndex) => {
                                if (currentSkuIndex === backupSkuModal.id) {
                                    backupSkuModal.sku = res.data;
                                }
                            });
                            this.setState({
                                skuModalComps: currentSkuModalComps
                            });  
                    } else {
                        currentSkuModalComps.map((backupSkuModal, madalIndex) => {
                            if (currentSkuIndex === backupSkuModal.id) {
    
                                backupSkuModal.skuInventory = "";
                                backupSkuModal.backupOnroadQuantity = "";
                                backupSkuModal.sku =''
                            }
                        });
                        this.setState({
                            skuModalComps: currentSkuModalComps
                        });
                    }
    
                }).catch(error => {
                    // console.log(error,"error")
                    currentSkuModalComps.map((backupSkuModal, madalIndex) => {
                        if (currentSkuIndex === backupSkuModal.id) {
                            backupSkuModal.sku =''
                        }
                    });

                    switch(error.status) {
                        case 'BLACK_SKU':
                            this.props.openNotification(currentSku.trim() + ': ' + T('sku_is_in_black_list'));
                           break;
                        case 'NOT_EXISTS':
                            this.props.openNotification(currentSku.trim() +': ' + T('sku_is_invalid_sku'));
                           break;
                        case 'EXIST_IN_CURRENT_SC':
                            this.props.openNotification(currentSku.trim() + ': ' + T('sku_is_exist_in_current_SC'));
                           break;
                        case 'HAS_NO_LIST_PRICE':
                            this.props.openNotification(currentSku.trim() + ': ' + T('sku_no_have_list_price'));
                           break;
                        default:
                            this.props.openNotification(T('notification_invalid_sku'));
                   } 
                    
                    this.setState({
                        skuModalComps: currentSkuModalComps
                    });
                });
            }
        }
    }

    addBackupSkuModal = () => {
        let { skuModalComps, skuNum } = this.state;
        skuModalComps.push({
            id: skuNum+1,
            sku: '',
            skuInventory: "",
            backupOnroadQuantity: "",
        });
        this.setState({
            skuModalComps: skuModalComps,
            skuNum: ++skuNum
        });
    }

    deletBackupSkuModal = (comps) => {
        let { skuModalComps } = this.state;
        if (skuModalComps.length > 1) {
            // skuModalComps.splice(comps-1,1);
            
            skuModalComps.splice(skuModalComps.findIndex(item => item.id === comps), 1)
            this.setState({
                skuModalComps: skuModalComps
            });
        } else {
            this.props.openNotification(T('apply_for_need_one_sku'));
        }
    }
    render() {
        const { scId, skuModalComps,pageLoading } = this.state;
        return (
            <div className="request-backup-container">
                <div className="request-backup-header container-max-width is-fixed">
                    <Anchor
                        className="back-btn"
                        onClickOfSingleTap={this.gotoBackupList}>
                        <ArrowBackIos className="back-icon" />
                    </Anchor>
                    {T('apply_for_listing_product')}
                </div>
                {
                    pageLoading ? <LoadingIcon className="page-loading circle-animation"/> :
                    <>
                    <section className="request-content">
                    <div className="row">
                        <label className="required-label">*</label>
                        <label>{T('backup_supply_center')}</label>
                        <Select
                            className="select"
                            value={scId}
                            placeholder={T('backup_supply_center_placeholder')}
                            data={this.props.SCList}
                            displayKey="name"
                            valueKey="id"
                            onChange={this.handleSelectChange}
                            options={{icon: {show: true, color: '#E82D38'}}}
                        />
                    </div>
                    <div className="row">
                        <label>{T('backup_comments')}</label>
                        <Input
                            type="text"
                            title="remark"
                            onChange={this.inputChange}
                            placeholder={T('backup_comments_placeholder')}
                        />
                    </div>
                </section>
                {skuModalComps.map((comps, index) => (
                    <section key={index + 1} className={"request-content sku-modal-" + comps.id }>
                        <div className="row">
                            <label className="required-label">*</label>
                            <label>{T('sku')}</label>
                            <Input type="text" disabled={scId ? false : true} title={"sku" + comps.id}
                                            value={comps.sku}
                                            key={comps.id}
                                            onChange={this.inputSkuQueryChange}
                                            onBlur={() => this.blurSkuQueryChange(comps.id)}
                                            placeholder={T('backup_please_input_sku')}/>
                            <Anchor className="delete-backup-a" onClickOfSingleTap={() => this.deletBackupSkuModal(comps.id) }>
                                <span className="backup-delete-btn">{ T('backup_delete_button') }</span>
                            </Anchor>
                        </div>
                    </section>
                ))}
                </>
                }
                <div className="add-apply-sku-div">
                    <BasicButton className="add-sku-area" onClickOfSingleTap={this.addBackupSkuModal}>
                        <label className="plus-label">+</label>
                        {T('backup_add_sku_button')}
                    </BasicButton>
                </div>
                <BasicButton
                    className="submit-btn"
                    type="primary"
                    onClickOfSingleTap={this.submit}>
                    {T('apply_backup_submit')}
                </BasicButton>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {localData, userCenter} = state;

    return {
        localData,
        SCList: userCenter.SCList,
        alphaList: userCenter.alphaList,
        inventoryInfor: userCenter.inventoryInfor
        
    };
};

const mapDispatchToProps = {
    getSCList,
    applyBackup,
    openNotification,
    getPersonalInfo,
    getAlphaList,
    getInventoryBySkuAndSC,
    checkSku,
    addApplyProduct
};

export default connect(mapStateToProps, mapDispatchToProps)(ApplyForListing);
